import { useFeatureToggle } from "./useFeatureToggle";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureToggle = ({
  children,
  name,
  off = null,
  on = null
}) => {
  const {
    enabled,
    isLoading
  } = useFeatureToggle(name);
  return isLoading ? null : /*#__PURE__*/_jsx(_Fragment, {
    children: enabled ? on ?? children : off
  });
};